import * as yup from 'yup';

import { translations } from 'locales/i18n';

import { ModuleSelection, SubjectType } from '../models';

export const moduleSelectionValidationSchema = t => ({
  subjectType: yup
    .string()
    .oneOf(['AWPM', 'FWPM'])
    .nullable()
    .required(t(translations.validation.required())),
  title: yup
    .string()
    .nullable()
    .required(t(translations.validation.required()))
    .label(t(translations.pages.moduleSelections.create.generalInfo.title())),
  generalNotes: yup
    .string()
    .when(['$state', 'title'], {
      is: (state, title) => state === 'DRAFT' && title,
      then: yup.string().nullable(),
      otherwise: yup.string().nullable().required(t(translations.validation.required()))
    })
    .label(t(translations.pages.moduleSelections.create.generalInfo.generalNotes())),
  electionTip: yup
    .string()
    .nullable()
    .label(t(translations.pages.moduleSelections.create.generalInfo.electionTip())),
  attachments: yup
    .mixed()
    .label(t(translations.pages.moduleSelections.create.generalInfo.attachments())),
  startDate: yup
    .date()
    .when(['$state', 'title'], {
      is: (state, title) => state === 'DRAFT' && title,
      then: yup.date().nullable(),
      otherwise: yup.date().nullable().required(t(translations.validation.required()))
    })
    .label(t(translations.pages.moduleSelections.create.periodsAndExtraInfo.startDate())),
  endDate: yup
    .date()
    .when(['$state', 'title'], {
      is: (state, title) => state === 'DRAFT' && title,
      then: yup.date().nullable(),
      otherwise: yup
        .date()
        .min(yup.ref('startDate'), t(translations.validation.endDateBeforeStartDate()))
        .nullable()
        .required(t(translations.validation.required()))
    })
    .label(t(translations.pages.moduleSelections.create.periodsAndExtraInfo.endDate())),
  contentVisibleFrom: yup
    .date()
    .nullable()
    .label(t(translations.pages.moduleSelections.create.periodsAndExtraInfo.contentVisibleFrom())),
  dischargeByStudentsUntil: yup
    .date()
    .min(yup.ref('endDate'), t(translations.validation.dischargeByStudentsUntilBeforeEndDate()))
    .nullable()
    .label(
      t(translations.pages.moduleSelections.create.periodsAndExtraInfo.dischargeByStudentsUntil())
    ),
  maxSelectedModules: yup
    .number()
    .when(['$state', 'title'], {
      is: (state, title) => state === 'DRAFT' && title,
      then: yup.number().nullable(),
      otherwise: yup.number().nullable().required(t(translations.validation.required()))
    })
    .label(t(translations.pages.moduleSelections.create.periodsAndExtraInfo.maxSelectedModules())),
  lengthOfTheWishlist: yup
    .number()
    .when(['$state', 'title'], {
      is: (state, title) => state === 'DRAFT' && title,
      then: yup.number().nullable(),
      otherwise: yup.number().nullable().required(t(translations.validation.required()))
    })
    .label(t(translations.pages.moduleSelections.create.periodsAndExtraInfo.lengthOfTheWishlist())),
  courseId: yup
    .number()
    .nullable()
    .label(t(translations.pages.modules.faculty()))
    .transform(value => (isNaN(value) ? null : value))
    .when('subjectType', {
      is: SubjectType.Fwpm,
      then: yup.number().nullable().required(t(translations.validation.required()))
    }),
  activeInAllCommunities: yup
    .boolean()
    .nullable()
    .label(
      t(translations.pages.moduleSelections.create.periodsAndExtraInfo.activeInAllCommunities())
    )
});

export const moduleSelectionInitialValues = ({
  subjectType,
  moduleSelectionToUpdate
}: {
  subjectType: SubjectType;
  moduleSelectionToUpdate?: ModuleSelection | undefined;
}) => {
  if (!moduleSelectionToUpdate) {
    return {
      subjectType,
      title: null,
      generalNotes: null,
      electionTip: null,
      attachments: [],
      startDate: null,
      endDate: null,
      contentVisibleFrom: null,
      dischargeByStudentsUntil: null,
      maxSelectedModules: null,
      lengthOfTheWishlist: null,
      activeInAllCommunities: null,
      courseId: '',
      observers: []
    };
  } else {
    return moduleSelectionToUpdate;
  }
};
